import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderService } from '../../../services';

import {  COMMENT, QUEUED, PRINTED, PREPRESS } from '../../../../ngrx/status-types';
import {  SET_ORDER_DETAILS_VIEW, SET_JOB_DETAILS_VIEW } from '../../../../ngrx/actions';
import { BsModalService } from 'ngx-bootstrap';
import { TranslateService } from 'app/i18n';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { REPRINTREASONS } from '../../../../ngrx/reprint-reasons';

@Component({
  selector: 'reprint-modal',
  templateUrl: 'reprint-modal.component.html',
  styleUrls:   ['reprint-modal.component.scss']
})
export class ReprintModal implements OnInit, OnDestroy {
  @ViewChild('selectInput') selectInput: ElementRef;
  @Input('reprintableJobs') reprintableJobs;
  @Input('job') job;
  @Input('currentStatus') currentStatus;
  @Input('cutting') cutting;
  reprintForm            : FormGroup;
  redownloadArtwork      : any;
  reprintReason          : string = "";
  location               : string;
  missingSheets          : string;
  numPages               : number;
  totalPages             : any;
  invalidPageMessage     : any;
  reprintMachine         : any;
  reprintProblem         : any;
  reprintDescription     : any;
  reprintReasonsList     : any = REPRINTREASONS;
  constructor(
    private orderService     : OrderService,
    private store            : Store<any>,
    private translate        : TranslateService,
    private modalService     : BsModalService,
    private fb               : FormBuilder,
  ) {
  }
  ngAfterViewInit() {
    // console.log(this.modalService.getModalsCount())
    // setTimeout(() => this.textInput.nativeElement.focus());
  }
  
  ngOnInit(): void {
    this.reprintReasonsList = REPRINTREASONS;
    if(this.job) {
      this.createReprintForm();
      this.reprintForm.setValue({
        reprintReason       : null,
        redownloadArtwork   : false,
        reprintSelectedPages: false,
        reprintNoOfPages    : false,
        totalPages          : this.job.isVariable ? 0 : 1,
        pages               : [],
        laserCutting        : null
      });
      this.numPages = Math.ceil((this.job.numPages || 1));

      this.totalPages = new Array(this.numPages);
      for (var i = 0; i < this.totalPages.length; i++) { 
        this.totalPages[i] = i+1;
      }
      // (<FormArray>this.reprintForm.get('totalPages')).push(this.fb.array(this.totalPages));

      (<FormArray>this.reprintForm.get('pages')).push(this.fb.group({
        pageFrom: 1,
        pageTo  : this.numPages,
        totalPages : this.numPages
      }));
    }
    // console.log("THIS.ORDER: ",this.order);
    console.log("reprint open");
  }

  createReprintForm(): void {
    this.reprintForm = this.fb.group({
      reprintReason       : [null, Validators.required],
      redownloadArtwork   : [false],
      reprintSelectedPages: [false],
      reprintNoOfPages    : [false],
      totalPages          : [0],
      pages               : this.fb.array([]),
      laserCutting        : [null]
    });
  }

  ngOnDestroy(): void {
    console.log("Destroying...")
    // this.initSubscriptions.forEach(subscription => subscription.unsubscribe());
    // !!this.cancelOrderModalRef && this.cancelOrderModalRef.hide();
    // !!this.changeHoldReasonModalRef && this.changeHoldReasonModalRef.hide();
    // !!this.customerDetailsModalRef && this.customerDetailsModalRef.hide();
    // !!this.onHoldModalRef && this.onHoldModalRef.hide();
    // !!this.reprintModalRef && this.reprintModalRef.hide();
  }

  addPagesCheck(): boolean {
    var previousPageTo = +(<FormArray>this.reprintForm.get('pages')).at((<FormArray>this.reprintForm.get('pages')).length-1).get('pageTo').value;
    if(previousPageTo == this.numPages){
      return true;
    } else {
      return false;
    }
  }

  addPages(): void {
    var previousPageTo = +(<FormArray>this.reprintForm.get('pages')).at((<FormArray>this.reprintForm.get('pages')).length-1).get('pageTo').value;
    if(previousPageTo == this.numPages){
      return;
    }
    var pFrom = previousPageTo + 1;
        pFrom = pFrom > this.numPages ? this.numPages : pFrom;
    (<FormArray>this.reprintForm.get('pages')).push(this.fb.group({
      pageFrom: pFrom,
      pageTo  : this.numPages,
      totalPages : (Number(this.numPages) + 1) - Number(pFrom)
    }));
    console.log(this.reprintForm.get('pages').value)
    console.log(this.reprintForm.get('pages').value.length - 1)

    this.syncPageFromTo(this.reprintForm.get('pages').value.length - 1, Number(pFrom), Number(this.numPages));
  }

  onMachineChange(machine) {
    console.log("on change",machine.problem.length)
    if(machine.problem.length === 1) {
      this.reprintProblem = machine.problem[0];
    } else {
      this.reprintProblem  = null;
    }
    this.reprintDescription  = null;
  }

  onProblemChange(problem) {
    console.log("on change",problem.description.length);
    if(problem.description.length === 1) {
      this.reprintDescription = problem.description[0];
    } else {
      this.reprintDescription  = null;
    }
  }

  checkPageValue() {
    const pages = this.reprintForm.value.totalPages;
    console.log("reprint form: ", typeof pages);
    console.log("pages form: ", pages);

    if(typeof pages !== 'number') {
      console.log("not a number");
      this.invalidPageMessage = 'PAGE_NOT_A_NUMBER';
    } else {
      this.invalidPageMessage = null;
    }
  }
  reprintOrder(): void {
    console.log(this.reprintReason)
    this.store.dispatch({
      type   : SET_ORDER_DETAILS_VIEW,
      payload: { loading: true }
    });

    if (this.reprintableJobs.length && this.reprintMachine && this.reprintProblem && this.reprintDescription) {
      this.reprintReason = '|' + this.reprintMachine.name + '|' + this.reprintProblem.name + "|" + this.reprintDescription + '|';
      // !!this.reprintModalRef && this.reprintModalRef.hide();
      let reprintSheetComment = '';
      this.redownloadArtwork = this.reprintMachine.name === 'Sistema' || this.reprintMachine.name === 'Customer Service' ? this.redownloadArtwork : false;
      if(this.redownloadArtwork) {
        reprintSheetComment = " | Artwork redownload"
      }
      console.log(`redownload artwork? ${this.redownloadArtwork}`);
      if(this.reprintDescription  === this.translate.instant('REPRINT_REASON.MISSING_SHEETS') && !!this.location && this.missingSheets) {
        reprintSheetComment = ' | ' + this.location + ' | ' + this.missingSheets + ' sheets missing';
      }
      const reprintableJobs = this.reprintableJobs.map(job => Object.assign({}, job, {
        pdfURL: this.redownloadArtwork ? `${job.pdfURL.trim()} `: job.pdfURL,
        jobLocation: job.jobLocation === PRINTED  ? null : job.jobLocation
      }));
      // console.log("translate: ",      this.translate.instant(this.reprintReason));
      if(this.job) {
        const { 
          pages,
          reprintSelectedPages,
          reprintNoOfPages,
          totalPages,
          laserCutting
        } = this.reprintForm.value;

        this.store.dispatch({
          type   : SET_JOB_DETAILS_VIEW,
          payload: { loading: true }
        });
        let updateJobStatusTo = QUEUED
        const updatedJob = Object.assign({}, this.job);
        if (this.redownloadArtwork) {
          updatedJob.pdfURL = `${this.job.pdfURL} `;
          // updatedJob.thumbURL = `${this.job.thumbURL} `;
          this.job.thumbURL = `${this.job.thumbURL}&d=`+ Date.now();
          updateJobStatusTo = PREPRESS
        }
        if(reprintNoOfPages) {
          // console.log("totalPages : ", totalPages)
          // console.log("totalPages : ", pages)
          updatedJob.reprint_pages = [{
            pageFrom: 1,
            pageTo  : totalPages,
            totalPages : totalPages
          }]
          this.reprintReason = '| ' + totalPages + ' ' + this.reprintReason;
        } else if (reprintSelectedPages && pages.length) {
          this.invalidPageMessage  = null;
          let totalSheets = 0;
          pages.forEach(page => {
            totalSheets += Number(page.totalPages);
          });
          // console.log("pages : ",pages);
          // console.log("pages : ",updatedJob.reprint_pages);
          updatedJob.reprint_pages = pages;
          this.reprintReason = '| ' + totalSheets + ' ' + this.reprintReason;
        } else {
          console.log("full reprint");
          updatedJob.reprint_pages = null;
          this.reprintReason = '| ' + this.numPages + ' ' + this.reprintReason;
        }
        // console.log("NEW REPRINT REASON : ", this.reprintReason);

        if(laserCutting) {
          updatedJob.preferredCutting = null;
        }
        this.orderService.setJobStatus(
          updatedJob,
          updateJobStatusTo,
          this.translate.instant(this.reprintReason),
          true,
          reprintSheetComment
        );
      } else {
        this.orderService.setJobStatuses(
          reprintableJobs,
          QUEUED,
          this.translate.instant(this.reprintReason),
          true,
          reprintSheetComment
        );  
      }
    }
    this.reprintReason     = '';
    this.missingSheets = null;
    this.location = '';
    this.redownloadArtwork = false;
    this.modalService.hide(1);
  }

  // reprintJob(): void {
  //   const { 
  //     pages,
  //     redownloadArtwork,
  //     reprintReason, 
  //     reprintSelectedPages,
  //     reprintNoOfPages,
  //     totalPages
  //   } = this.reprintForm.value;

  //   console.log("reprint form: ",this.reprintForm.value);

  //   if (reprintReason) {
  //     this.store.dispatch({
  //       type   : SET_JOB_DETAILS_VIEW,
  //       payload: { loading: true }
  //     });

  //     const updatedJob = Object.assign({}, this.job);
  //     let missingSheetsComment = ''

  //     var updateJobStatusTo = QUEUED;
  //     if (redownloadArtwork && reprintReason === this.translate.instant('REPRINT_REASON.EDITED')) {
  //       console.log(`redownloading artwork for Job ${this.job.id}`);
  //       missingSheetsComment = ' | Artwork redownload';
  //       updatedJob.pdfURL = `${this.job.pdfURL} `;
  //       // updatedJob.thumbURL = `${this.job.thumbURL} `;
  //       this.job.thumbURL = `${this.job.thumbURL}&d=`+ Date.now();
  //       updateJobStatusTo = PREPRESS
  //     }
  //     if (reprintReason === this.translate.instant('REPRINT_REASON.MISSING_SHEETS') && !!this.location && !!this.missingSheets) {
  //       missingSheetsComment = ' | ' + this.location + ' | ' + this.missingSheets + ' sheets missing';
  //     }

  //     if (reprintSelectedPages || reprintNoOfPages) {
  //       this.invalidPageMessage  = null;
  //       pages[0].totalPages = totalPages ? totalPages : null;
  //       updatedJob.reprint_pages = pages;
  //     } else {
  //       updatedJob.reprint_pages = null;
  //     }
  //     updatedJob.batchId = null; // clear batchId if it's still there 
  //     console.log("TOTAL NUMBER OF PAGES FOR SHEETS NON VDP : ",totalPages);
  //     updatedJob.jobLocation = this.currentStatus === PRINTED ? null : updatedJob.jobLocation;
  //     this.orderService.setJobStatus(
  //       updatedJob,
  //       updateJobStatusTo,
  //       this.translate.instant(reprintReason),
  //       true,
  //       missingSheetsComment
  //     );
  //   }
  // }
  syncPageFromTo(index: number, pageF: number,pageT: number): void {
    console.log(`SyncPageFromTo -> PageFrom: ${pageF}, PageTo: ${pageT}`);
    if (+pageT < +pageF) {
      console.log(`Setting PageFrom equal to PageTo: ${pageT}`);
      this.invalidPageMessage = 'PAGE_FROM_ERROR1';
      pageF                   = pageT;
    }
    
    if(index != 0){
      const previousTo = +(<FormArray>this.reprintForm.get('pages')).at(index-1).get('pageTo').value;
      if(+pageF <= +previousTo){
        pageF                   = +previousTo +1;
        this.invalidPageMessage = this.invalidPageMessage == null ? 'PAGE_FROM_ERROR2' : 'PAGE_FROM_ERROR1N2';
        if(+pageF == this.numPages || +pageF > +pageT){
          pageT = pageF;
        }
      }
    }
    (<FormArray>this.reprintForm.get('pages')).at(index).get('pageFrom').setValue(Number(pageF));
    (<FormArray>this.reprintForm.get('pages')).at(index).get('pageTo').setValue(Number(pageT));
    (<FormArray>this.reprintForm.get('pages')).at(index).get('totalPages').setValue((Number(pageT) + 1)- Number(pageF));
    console.log(this.reprintForm.get('pages').value)
  }
  removePages(index: number): void {
    (<FormArray>this.reprintForm.get('pages')).removeAt(index);
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/modals/reprint-modal/reprint-modal.component.ts